import createNeighborWeightsV2 from "./createNeighborWeightsV2"
import createXYCacheFactory from "./createXYCacheFactory"

const getNeighborWeightsV2Cached = createXYCacheFactory(createNeighborWeightsV2)

export default getNeighborWeightsV2Cached
